import Vue from 'vue'
import axios from 'axios'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import moment from 'moment'
import store from '@/store'

export const ACCESS_AUTHENTICATION = 'authentication'
export const ACCESS_LANG = 'lang'
export const ACCESS_FRAME = 'frame'
export const ACCESS_SERVICES = 'services'

export const call = ({access, url, method, ...args}) => new Promise((resolve, reject) => {
  store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_REQUEST_LOADING}`, { }, {root: true})

  try {
    var accessUrl = ''
    if (access === ACCESS_AUTHENTICATION) {
      accessUrl = Vue.config.sherpaCrm.API_AUTHENTICATION_URL
    } else if (access === ACCESS_LANG) {
      accessUrl = Vue.config.sherpaCrm.API_LANG_URL
    } else if (access === ACCESS_FRAME) {
      accessUrl = Vue.config.sherpaCrm.API_FRAME_URL
    } else if (access === ACCESS_SERVICES) {
      accessUrl = Vue.config.sherpaCrm.API_SERVICES_URL
    } else {
      reject(new Error('Api Call Access Not Defined'))
    }

    // avoid browser cache
    accessUrl += moment().valueOf() + url

    var requestData = {}
    if (method === 'POST') {
      requestData = {
        requestHeader: getAppRequestHeader()
      }
      if (access !== ACCESS_AUTHENTICATION) {
        requestData.requestContent = args.data
      }
    } else if (method === 'GET') {
      requestData = {}
    } else {
      reject(new Error('Api Call Method Not Defined'))
    }

    var userToken = localStorage.getItem('user-token')
    var authorizationStr = ''
    if (access === ACCESS_AUTHENTICATION) {
      if (userToken && userToken !== '') {
        authorizationStr = userToken
      } else {
        authorizationStr = 'Credentials ' + btoa(JSON.stringify(args.data))
      }
    } else if (access === ACCESS_LANG) {
      authorizationStr = ''
    } else {
      authorizationStr = userToken
    }

    resolve(
      axios({
        method: method,
        url: accessUrl,
        data: requestData,
        headers: {
          authorization: authorizationStr
        }
      })
        .then(function (response) {
          // Setejar l'user-token al logar-se
          // Refrescar l'user-token al demanar les dades de profile
          if (access === ACCESS_AUTHENTICATION) {
            var token = ''
            if (response.headers.authorization) {
              token = response.headers.authorization
            }
            localStorage.setItem('user-token', token)
          }
          store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_SUCCESS}`, { }, {root: true})
          return response.data
        })
    )
  } catch (err) {
    reject(new Error(err))
  }
})

function getAppRequestHeader () {
  return {
    'acceptLanguage': navigator.language,
    'externalReferer': document.referrer,
    'lang': store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`],
    'referer': document.location.href,
    'userAgent': navigator.userAgent,
    'product': navigator.product,
    'platform': navigator.platform,
    'vendor': navigator.vendor
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js